<template>
  <v-select
    style="max-width: 15%"
    class="mr-5"
    v-model="localeValue"
    :items="$i18n.availableLocalesLabels"
    :menu-props="{ contentClass: 'select-lang' }"
    label="Select"
    hide-details
    append-icon="mdi-web"
    :item-text="$vuetify.breakpoint.smAndDown ? '.value' : '.text'"
    single-line
    @change="saveLocalStorage"
  ></v-select>
</template>

<script>
import axios from "axios";
import { localize } from "vee-validate";

export default {
  name: "Snackbar",
  data() {
    return {
      localeValue: this.$i18n.locale,
      itemsList: this.$i18n.availableLocalesLabels,
    };
  },
  methods: {
    saveLocalStorage() {
      window.localStorage.setItem("localeValue", this.localeValue);
      this.$i18n.locale = this.localeValue;
      this.$vuetify.lang.current = this.localeValue;
      axios.defaults.headers.common["X-App-Locale"] = this.localeValue;
      localize(this.localeValue);
    },
  },
};
</script>